import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import { Envs } from '../envs.js';

class IuguTokenizer {
  loadIuguScript() {
    return new Promise((resolve, reject) => {
      if (typeof (window === null || window === void 0 ? void 0 : window.Iugu) !== 'undefined') return resolve(true);
      const script = document.createElement('script');
      script.src = 'https://js.iugu.com/v2';
      script.type = 'text/javascript';
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error('Failed to load Iugu script'));
      document.head.appendChild(script);
    });
  }
  tokenize({
    number,
    expiration,
    holder,
    cvv
  }) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      yield this.loadIuguScript();
      const [month, year] = expiration.split('/');
      const firstName = holder.split(' ').slice(0, 1).join(' ');
      const lastName = holder.split(' ').slice(-1).join(' ');
      (_a = window === null || window === void 0 ? void 0 : window.Iugu) === null || _a === void 0 ? void 0 : _a.setAccountID(Envs.IUGU_ACCOUNT_ID);
      (_b = window === null || window === void 0 ? void 0 : window.Iugu) === null || _b === void 0 ? void 0 : _b.setTestMode(Envs.IUGU_TEST_MODE === 'true');
      (_c = window === null || window === void 0 ? void 0 : window.Iugu) === null || _c === void 0 ? void 0 : _c.setup();
      return new Promise((resolve, reject) => {
        var _a, _b;
        return (_a = window === null || window === void 0 ? void 0 : window.Iugu) === null || _a === void 0 ? void 0 : _a.createPaymentToken((_b = window === null || window === void 0 ? void 0 : window.Iugu) === null || _b === void 0 ? void 0 : _b.CreditCard(number, month, year, firstName, lastName, cvv), response => {
          if (response.errors) {
            return reject(JSON.stringify(response.errors));
          }
          resolve({
            tokenId: response.id
          });
        });
      });
    });
  }
}

export { IuguTokenizer };
